export const TYPES = {
  LASTNAME: 'lastname',
  FIRSTNAME: 'firstname',
  SSN: 'ssn',
  DATE: 'date',
}

// Manually format a date-of-birth input as `dd-mm-yyyy`.
// We do this instead of react-input-mask because that library (v2.x) is not
// compatible with React 18 and fails to propagate the value for the masked
// DoB field, which is why DoB search stopped working.
export const formatDateInput = raw => {
  const digits = String(raw ?? '')
    .replace(/\D/g, '')
    .slice(0, 8) // ddmmyyyy
  const day = digits.slice(0, 2)
  const month = digits.slice(2, 4)
  const year = digits.slice(4, 8)

  let out = day
  if (digits.length > 2) out += `-${month}`
  if (digits.length > 4) out += `-${year}`
  return out
}

// A fully entered dd-mm-yyyy value is exactly 10 characters.
export const isCompleteDate = value => typeof value === 'string' && value.length === 10
